import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import {AccountService} from '../../../../configuration-management/services/account.service';
import {LocationService} from '../../../../configuration-management/services/location.service';
import {LineItemInputService} from '../../../../line-item-entry/services/line-item-input.service';
import {
  LineItem,
  LineItemLocation,
  LineItemSubmission, LineItemTypesWithOverrides, ReminderOverrideBinding, ReminderOverrideView
} from '../../../../line-item-entry/models/line-item.interface';
import {UserAccount, UserOption} from '../../../../configuration-management/models/user.interface';
import {MatDialog} from '@angular/material/dialog';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {UpdateLineItems, UpdateLineItemsComponent} from './update-line-items/update-line-items.dialog';
import {DiscountsService} from 'src/app/configuration-management/services/discounts.service';
import {DiscountSummary} from 'src/app/configuration-management/models/discounts.interface';
import {MatSnackBar} from '@angular/material/snack-bar';
import {GroupInvoiceItemsComponent} from './group-items/group-invoice-items.dialog';
import {SearchService} from '../../../search/search-service';
import {Client} from 'src/app/client-management/models/client.interface';
import {Patient} from 'src/app/patient-management/models/patient.interface';
import {PrintDialogComponent} from './print-dialog/print.dialog';
import {LabsService} from '../../../../configuration-management/services/labs.service';
import {
  EntityWithLineItemsReference,
  EntityWithLineItemsType,
  Invoice
} from '../../../../line-item-entry/models/invoice.interface';
import {InvoiceSelectionComponent} from './invoice-selection/invoice-selection.dialog';
import {MissingItemsDialogComponent} from '../missing-items-dialog/missing-items.dialog';
import {FormControl} from '@angular/forms';
import {ConfirmationDialogComponent} from '../../../confirmation-dialog/confirmation.dialog';
import {PatientService} from '../../../../patient-management/services/patient.service';
import {RefillsDialogComponent} from './refills-dialog/refills.dialog';
import {RefillsDialogData} from 'src/app/requests-results/models/request.interface';
import {RequestService} from 'src/app/requests-results/services/request.service';
import {FileUploadModel} from 'src/app/patient-management/patient-record/patient-picture-dialog/patient-picture.dialog';
import {Subscription} from 'rxjs';
import {LocationSummary} from '../../../../configuration-management/models/locations.interface';
import {EstimateService} from '../../../../line-item-entry/services/estimate.service';
import {FeatureFlag} from '../../../../config.model';
import {FeatureFlagService} from '../../../../feature-flag.service';
import {storage} from '../../../local-storage/local-storage.service';
import {LocalStorageNames} from '../../../local-storage/local-storage.enum';
import {
  OverviewReminderOverrideDialogComponent, OverviewReminderOverrideDialogData
} from '../../../overview-reminder-override-dialog/overview-reminder-override.dialog';
import {SearchLineItemDataService} from '../../../search/data-services/search-line-item-data.service';
import {StatementService} from '../../../../list-communications/services/statements.service';
import {ListCommunicationsService} from '../../../../list-communications/services/list-communications.service';
import FileSaver from 'file-saver';
import {
  ControlledSubstanceLogDialogComponent
} from '../../../controlled-substance-log-dialog/controlled-substance-log.dialog';
import {InvoiceService} from '../../../../line-item-entry/services/invoice.service';
import { InvoiceEventService } from 'src/app/shared/services/invoice-event.service';
import {
  ControlledSubstanceLogEntry,
  ControlledSubstanceLogDialogResult
} from '../../../../configuration-management/models/controlled-substance-logs.models';

@Component({
  selector: 'app-line-item-form',
  templateUrl: './line-item-form.component.html',
  styleUrls: ['./line-item-form.component.scss'],
  providers: [SearchLineItemDataService],
})
export class LineItemFormComponent implements OnInit, OnDestroy {
  // The all-zero GUID. Used as the sentinel invoice id for the co-occurrence check on a
  // not-yet-saved invoice (the server treats Guid.Empty as "no telemetry" and still returns
  // warnings), and as the id a persisted patientless invoice comes back with.
  private static readonly EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
  @Input() lineItemList: LineItem[] = [];
  @Input() selectedClient: Client;
  @Input() invoiceData: EntityWithLineItemsReference;
  @Input() selectedPatient: Patient;
  @Input() closed: boolean;
  @Input() clientInvoices: Invoice[];
  @Input() lineItemDraft: Invoice[];
  @Input() keepRevisions = false;
  @Input() allowConvertingToEstimate = false;
  @Output() updateInvoice = new EventEmitter<Invoice>();
  @ViewChild('table', { static: false }) table: MatTable<any>;
  searchCtrl = null;
  searchCtrl2 = null;
  baseDisplayedColumns: string[] = [
    'add',
    'index',
    'select',
    'location',
    'code',
    'date',
    'doctor',
    'asst',
    'quan',
    'price',
    'discount',
    'total',
    'comments',
    'actions',
  ];

  get displayedColumns(): string[] {
    const columns = [...this.baseDisplayedColumns];
    const cslIndex = columns.indexOf('date');

    // Check if any line items are controlled substances
    const hasControlledSubstances = this.dataSource.data && this.dataSource.data.some(item => item.isControlledSubstance);

    if (hasControlledSubstances) {
      columns.splice(cslIndex, 0, 'controlledsubstancelog');
    }

    return columns;
  }
  dataSource = new MatTableDataSource<LineItem>([]);
  selection = new SelectionModel<LineItem>(true, []);
  lineItemClipboard: LineItem[];
  hoveredIndex: string;
  autocompleteIndex: number;
  defaultDate = new Date();
  dateOfWork = new Date(
    this.defaultDate.getFullYear(),
    this.defaultDate.getMonth(),
    this.defaultDate.getDate(),
  );
  locations = [];
  locationNames = new Map<string, string>();
  selectedLocation: LineItemLocation;
  searchString = new FormControl('');
  lineItems: LineItem[];
  lineItemsToPrint = [];
  doctor: UserOption;
  asstDoctor = new UserOption();
  doctors: UserOption[];
  discounts: DiscountSummary[];
  discount = new DiscountSummary();
  groupPosition = 0;
  submission = new LineItemSubmission();
  submitted = false;
  isCollapsed = false;
  files: Array<FileUploadModel> = [];
  waitingOnFileUpload = false;
  isCheckingMissingItems = false;
  // Guards the co-occurrence check + warning dialog window against a second
  // submit click (which would duplicate charges); see submitLineItems.
  isSubmitting = false;
  totalOfAllLineItems = 0;
  subscriptions = new Subscription();
  expandedPanelIndex: number | null = 0;
  controlledSubstanceLogData = new Map<string, ControlledSubstanceLogEntry>();
  sendEstimateEmail = false;
  printEstimateAfterSubmit = false;

  areEstimatesEnabled: boolean;

  constructor(
    public accountService: AccountService,
    public locationService: LocationService,
    public lineItemInputService: LineItemInputService,
    public lineItemDataService: SearchLineItemDataService,
    public estimateService: EstimateService,
    public dialog: MatDialog,
    public discountsService: DiscountsService,
    public snackBar: MatSnackBar,
    public searchService: SearchService,
    private cdr: ChangeDetectorRef,
    public labsService: LabsService,
    public statementService: StatementService,
    public listCommunicationsService: ListCommunicationsService,
    public patientService: PatientService,
    public iconRegistry: MatIconRegistry,
    public sanitizer: DomSanitizer,
    public requestService: RequestService,
    public featureFlags: FeatureFlagService,
    public invoiceService: InvoiceService,
    public invoiceEventService: InvoiceEventService
  ) {
    this.isCollapsed = window.innerWidth < 700;

    iconRegistry.addSvgIcon(
      'request-results-icon-grey',
      sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/icon-lab-grey@1x.svg',
      ),
    );
    iconRegistry.addSvgIcon(
      'request-results-icon-blue',
      sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/icon-lab-blue@1x.svg',
      ),
    );
    iconRegistry.addSvgIcon(
      'request-results-icon-red',
      sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/icon-lab-red@1x.svg',
      ),
    );
  }

  ngOnInit() {
    this.areEstimatesEnabled = this.featureFlags.getFeatureFlag(
      FeatureFlag.estimatesFlag,
    );

    if (this.invoiceData == null) {
      this.invoiceData = new EntityWithLineItemsReference();
    }

    this.subscriptions.add(this.searchString.valueChanges.subscribe((value) => {
      return this.lineItemDataService.input(value, true);
    }
    ));
    this.subscriptions.add(
      this.lineItemDataService.fetch.dataReceived.subscribe(
        this.setLineItems.bind(this),
      ),
    );
    this.dataSource.data = this.lineItemList;
    this.getDoctors();
    this.getDiscounts();

    const estimatePublished = storage.getItem<boolean>(
      LocalStorageNames.EstimatePublished,
      false,
    );
    if (estimatePublished) {
      storage.setItem(LocalStorageNames.EstimatePublished, false);
      this.publishEstimateItems();
    }

    // Read persisted clipboard
    this.lineItemClipboard = storage.getItem<LineItem[]>(
      LocalStorageNames.LineItemClipboard,
      [],
    );
    if (this.lineItemClipboard == null) {
      this.lineItemClipboard = [];
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    this.lineItemDataService.dispose();
  }

  private renderTableRows(): void {
    if (this.table) {
      this.table.renderRows();
    }
  }

  get validateForm() {
    return (
      this.dataSource.data.filter(
        (x) =>
          x.name == null ||
          x.itemId == null ||
          x.name === '' ||
          x.itemId === '',
      ).length > 0
    );
  }

  getTotalPrice(item: LineItem) {
    if (item.itemId === null || item.itemId === undefined || item.itemId === '') {
      return '0';
    }

    if (item.discountId) {
      item.totalPrice = this.calculateLineItemPrice(item) * item.discount.decimalPercentage;
      this.calculateInvoiceTotal();
      return (this.calculateLineItemPrice(item) * item.discount.decimalPercentage).toFixed(2);
    }
    item.totalPrice = this.calculateLineItemPrice(item);
    this.calculateInvoiceTotal();
    return this.calculateLineItemPrice(item).toFixed(2);
  }

  setLocations(response: LocationSummary[]) {
    this.locations = response;

    if (this.accountService.currentUserValue.defaultLocationId !== null) {
      // tslint:disable-next-line: max-line-length
      this.selectedLocation = JSON.parse(
        JSON.stringify(
          this.locations.filter(
            (x) =>
              x.id === this.accountService.currentUserValue.defaultLocationId,
          ),
        ),
      ) as LineItemLocation;
    } else {
      this.selectedLocation = JSON.parse(
        JSON.stringify(this.locations[0]),
      ) as LineItemLocation;
    }

    // Build a lookup for full location names (used by template tooltips)
    this.locationNames = new Map(this.locations.map(loc => [loc.id, loc.name]));

    if (this.dataSource.data.length > 0) {
      // Set Default Doctor
      this.doctor = JSON.parse(JSON.stringify(this.dataSource.data[0].doctor));
      this.doctor.doctorCode = this.dataSource.data[0].doctorCode;

      this.asstDoctor = JSON.parse(
        JSON.stringify(this.dataSource.data[0].asstDoctor),
      );
      this.asstDoctor.doctorCode = this.dataSource.data[0].assistingDoctorCode;
      // Set Default Date
      this.dateOfWork = JSON.parse(
        JSON.stringify(this.dataSource.data[0].dateOfWork),
      );
      // Set Default Location
      this.selectedLocation = JSON.parse(
        JSON.stringify(this.dataSource.data[0].location),
      );
    }
    // Ensure there's always at least one empty row for new invoices
    if (this.dataSource.data.length === 0 && this.invoiceData.id == null) {
      this.addRow(0);
      this.setLocation(
        this.dataSource.data[0].location[0].id,
        this.dataSource.data[0],
      );
      this.renderTableRows();
    }
  }

  setItemValue(searchString: string) {
    this.searchString.setValue(searchString);
  }

  setLineItems(results: LineItem[]) {
    if (results) {
      this.lineItems = results;
    }
  }

  selectItem(item: LineItem, currentLineItem: LineItem) {
    currentLineItem.totalPrice = item.totalPrice;
    currentLineItem.discountName = item.discountName;
    currentLineItem.code = item.code;
    currentLineItem.nameNoCode = item.nameNoCode;
    currentLineItem.pricePerUnit = item.pricePerUnit;
    currentLineItem.hasAttachment = item.hasAttachment;
    currentLineItem.quantity = item.quantity;
    currentLineItem.name = item.name;
    currentLineItem.itemId = item.id;
    currentLineItem.lineItemCategory = item.lineItemCategory;
    currentLineItem.location = JSON.parse(
      JSON.stringify(this.selectedLocation),
    );
    currentLineItem.approved = false;
    currentLineItem.approvedUserId = '';
    currentLineItem.needsRequest = item.needsRequest;
    currentLineItem.isControlledSubstance = item.isControlledSubstance;
    currentLineItem.causesDeath = item.causesDeath;
    currentLineItem.instructions = item.instructions;
    currentLineItem.minimumCost = item.minimumCost;
    currentLineItem.reminderOverrides = [];

    if (item.lineItemCategory === 'Group') {
      this.groupItemDialog(
        JSON.parse(JSON.stringify(item.groupItems)),
        currentLineItem.position,
      );
    }
    this.showLineItemDialogs(currentLineItem);
  }

  showLineItemDialogs(item: LineItem) {
    if (!this.invoiceData.isEstimate) {
      if (item.causesDeath === true) {
        this.invoiceService.euthanasiaDialog(this.selectedPatient);
      }
      if (item.isControlledSubstance === true) {
        this.controlledSubstanceDialog(item);
      }
      if (LineItemTypesWithOverrides.includes(item.lineItemCategory)) {
        this.checkReminderOverride(item);
      }
    }
  }

  checkReminderOverride(item: LineItem) {
    const sub = this.searchService.overviewReminderOverrides(item.itemId, item.lineItemCategory)
      .subscribe(
      res => {
        for (const reminder of res) {
          this.openOverrideDialog(item, reminder);
        }
      }
    );
    this.subscriptions.add(sub);
  }

  openOverrideDialog(item: LineItem, reminder: ReminderOverrideView) {
    const dialogRef =
      this.dialog.open<
        OverviewReminderOverrideDialogComponent,
        OverviewReminderOverrideDialogData,
        ReminderOverrideBinding>
      (OverviewReminderOverrideDialogComponent, {
        width: '450px',
        data: {patient: this.selectedPatient, reminder}
      });
    const sub = dialogRef.afterClosed().subscribe(response => {
      if (response) {
        if (item.reminderOverrides == null) {
          item.reminderOverrides = [];
        }
        item.reminderOverrides.push(response);
      }
    });
    this.subscriptions.add(sub);
  }

  downloadTemplate(lineItem: LineItem) {
    this.labsService
      .getPatientLabPDF(
        lineItem.itemId,
        this.selectedPatient.id,
        this.doctor.id,
      )
      .subscribe((blob) => {
        FileSaver.saveAs(
          blob,
          this.selectedPatient.name + ' ' + lineItem.name + '.pdf',
        );
      });
  }

  getFilesAndUpload(item: LineItem) {
    const fileUpload = document.getElementById(
      'fileUpload',
    ) as HTMLInputElement;
    fileUpload.onchange = () => {
      // tslint:disable-next-line:prefer-for-of
      for (let index = 0; index < fileUpload.files.length; index++) {
        const file = fileUpload.files[index];
        this.files.push({
          data: file,
          state: 'in',
          inProgress: false,
          progress: 0,
          canRetry: false,
          canCancel: true,
        });
      }
      this.uploadFiles(item);
    };
    fileUpload.click();
  }

  uploadFiles(item: LineItem) {
    this.waitingOnFileUpload = true;
    const fileUpload = document.getElementById(
      'fileUpload',
    ) as HTMLInputElement;
    fileUpload.value = '';

    if (this.files.length >= 1) {
      const files = this.files.map((element) => element.data);

      this.requestService
        .uploadLabRequestFileTemporarilySavedOnQuickEntry(files)
        .subscribe(
          (result) => {
            this.files = [];
            item.labRequestTemporaryS3FileId = result.fileId;
            this.snackBar.open(
              'Patient file successfully uploaded',
              'Success',
              {
                duration: 2000,
              },
            );
            this.waitingOnFileUpload = false;
          },
          (error) => {
            this.snackBar.open('Patient file was not uploaded', 'Error', {
              duration: 2000,
            });
            this.files = [];
            this.waitingOnFileUpload = false;
          },
        );
    }
  }

  controlledSubstanceDialog(lineItem: LineItem) {
    if (!this.selectedPatient || !this.selectedClient) {
      this.snackBar.open('Patient or Client information is missing', 'Error', {
        duration: 2000,
      });
      return;
    }

    const cslData = {
      medicationSupplyId: lineItem.itemId || '',
      requestedForUserId: lineItem.doctor.id || '',
      date: lineItem.dateOfWork || new Date(),
      patientId: this.selectedPatient.id || '',
      locationId: lineItem.location.id || '',
      bottleEntries: lineItem.controlledSubstanceLogs ? lineItem.controlledSubstanceLogs.map(log => ({
        id: log.id || '',
        controlledSubstanceBottleId: log.controlledSubstanceBottleId || '',
        bottleId: log.bottleId || 0,
        locationId: log.currentBottleLocationId || log.locationId || '',
        amountAdministered: log.amountAdministered || 0,
        wastage: log.wastage || 0,
        balanceOnHand: log.balanceOnHand || 0,
        originalBalance: (log.originalBalance || log.originalBalance === 0) ? log.originalBalance : (log.balanceOnHand || 0) + (log.amountAdministered || 0) + (log.wastage || 0),
        notes: log.note || '',
        isFinished: log.isFinished || false,
        isMoveLocation: log.isMoveLocation || false,
        lineItemName: log.lineItemName || '',
      })) : [],
    };

    const dialogRef = this.dialog.open(ControlledSubstanceLogDialogComponent, {
      width: '1200px',
      height: '800px',
      data: {
        lineItem,
        patientId: this.selectedPatient.id,
        patient: this.selectedPatient,
        client: this.selectedClient,
        cslData: cslData
      },
    });

    const sub = dialogRef.afterClosed().subscribe((res: ControlledSubstanceLogDialogResult) => {
      this.handleControlledSubstanceDialogClose(res, lineItem);
    });
    this.subscriptions.add(sub);
  }

  private handleControlledSubstanceDialogClose(res: ControlledSubstanceLogDialogResult, lineItem: LineItem): void {
    if (res && res.controlledSubstanceLogs) {
      // Attach the list of ControlledSubstanceLogV2BindingModels to the line item (one per bottle)
      lineItem.controlledSubstanceLogs = res.controlledSubstanceLogs;

      // Update the quantity based on the total amount administered from all bottles
      lineItem.quantity = res.totalAmountAdministered;

      const doctor = res.formData.requestedForUser;
      lineItem.doctor = JSON.parse(JSON.stringify(doctor));
      lineItem.doctorCode = doctor.doctorCode;

      const foundLocation = this.locations.find((x) => x.id === res.formData.locationId);
      if (foundLocation) {
        lineItem.location = foundLocation;
      }

      lineItem.dateOfWork = res.formData.date;

      console.log('Controlled Substance Logs attached to line item:', lineItem.controlledSubstanceLogs);
      this.snackBar.open(`${lineItem.controlledSubstanceLogs.length} controlled substance log(s) attached to line item`, 'Success', {
        duration: 2000,
      });
    }
  }

  groupItemDialog(groupItems: LineItem[], position: number) {
    const dialogRef = this.dialog.open(GroupInvoiceItemsComponent, {
      width: '450px',
      data: groupItems,
    });
    this.groupPosition = position;

    dialogRef.afterClosed().subscribe((lineItems) => {
      if (lineItems != null) {
        lineItems.forEach((lineItem) => {
          this.addLineItemRow(this.groupPosition, lineItem);

          this.showLineItemDialogs(this.dataSource.data[this.groupPosition]);

          this.groupPosition = position + 1;
        });
        this.groupPosition = 0;
      }
    });
  }

  publishEstimateItems() {
    this.dataSource.data.forEach((item) => {
      if (item.causesDeath === true) {
        this.invoiceService.euthanasiaDialog(this.selectedPatient);
      }

      if (LineItemTypesWithOverrides.includes(item.lineItemCategory)) {
        this.checkReminderOverride(item);
      }
    });
  }

  addLineItemRow(index: number, newLineItem: LineItem) {
    this.canEditInvoice();
    this.dataSource.data
      .filter((x) => x.position > index)
      .sort((x) => x.position)
      .forEach((lineItem) => {
        lineItem.position = lineItem.position + 1;
      });
    const item = newLineItem;
    item.approved = false;
    item.position = index + 1;
    item.dateOfWork = this.dateOfWork;
    item.groupItemItemId = newLineItem.itemId || '';
    item.itemId = newLineItem.id;
    item.doctor = JSON.parse(JSON.stringify(this.doctor)) as UserAccount;
    item.location = JSON.parse(
      JSON.stringify(this.selectedLocation),
    ) as LineItemLocation;
    item.asstDoctor = JSON.parse(
      JSON.stringify(this.asstDoctor),
    ) as UserAccount;
    item.doctorCode = this.doctor.doctorCode;
    item.assistingDoctorCode = this.asstDoctor.doctorCode;
    item.discount = JSON.parse(
      JSON.stringify(this.discount),
    ) as DiscountSummary;
    if (item.discount != null) {
      item.discountId = item.discount.id;
    }
    item.id = null;

    this.dataSource.data.push(item);

    if (this.dataSource.data.length > 1) {
      this.dataSource.data = this.dataSource.data
        .sort((a, b) => a.position - b.position)
        .map((x) => x);
    }

    this.renderTableRows();
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  handleMouseOver(row) {
    this.hoveredIndex = row.position;
  }

  canEditInvoice() {
    if (this.closed === true && !this.accountService.canFinalize) {
      this.snackBar.open('User is not allowed to edit invoice.', 'Error', {
        duration: 2000,
      });
      throw new Error('User is not allowed to edit invoice');
    }
  }

  approveSelected() {
    this.canEditInvoice();
    this.selection.selected.forEach((lineItem) => {
      this.setApproved(lineItem);
    });
  }

  addRow(index) {
    this.canEditInvoice();
    this.dataSource.data
      .filter((x) => x.position > index)
      .sort((x) => x.position)
      .forEach((lineItem) => {
        lineItem.position = lineItem.position + 1;
      });

    const item = new LineItem();
    item.position = index + 1;
    item.name = '';
    item.isPrinted = false;

    if (index !== 0) {
      const aboveItem = JSON.parse(
        JSON.stringify(this.dataSource.data[index - 1]),
      ) as LineItem;

      item.dateOfWork = aboveItem.dateOfWork;
      this.dateOfWork = aboveItem.dateOfWork;
      item.doctorCode = aboveItem.doctorCode;
      item.doctor = JSON.parse(JSON.stringify(aboveItem.doctor)) as UserAccount;
      item.assistingDoctorCode = aboveItem.assistingDoctorCode;
      item.asstDoctor = JSON.parse(
        JSON.stringify(aboveItem.asstDoctor),
      ) as UserAccount;
      item.location = JSON.parse(
        JSON.stringify(aboveItem.location),
      ) as LineItemLocation;
      item.discount = JSON.parse(
        JSON.stringify(aboveItem.discount),
      ) as DiscountSummary;
      if (aboveItem.discount != null) {
        item.discountId = aboveItem.discountId;
      }
    } else {
      item.dateOfWork = this.dateOfWork;
      item.doctorCode = this.doctor.doctorCode;
      item.doctor = JSON.parse(JSON.stringify(this.doctor)) as UserAccount;
      item.assistingDoctorCode = this.asstDoctor.doctorCode;
      item.location = JSON.parse(
        JSON.stringify(this.selectedLocation),
      ) as LineItemLocation;
      item.asstDoctor = JSON.parse(
        JSON.stringify(this.asstDoctor),
      ) as UserAccount;
      item.discount = JSON.parse(
        JSON.stringify(this.discount),
      ) as DiscountSummary;
      if (item.discount != null) {
        item.discountId = item.discount.id;
      }
    }

    this.dataSource.data.push(item);

    if (this.dataSource.data.length > 1) {
      this.dataSource.data = this.dataSource.data
        .sort((a, b) => a.position - b.position)
        .map((x) => x);
    }

    // Expand the newly added item in mobile view
    if (this.isCollapsed) {
      this.expandedPanelIndex = index;
    }

    this.renderTableRows();
  }

  calculateInvoiceTotal() {
    let total = 0;
    this.dataSource.data.forEach((x) => {
      total += x.totalPrice || 0;
    });

    this.totalOfAllLineItems = total;
  }

  setApproved(item: LineItem) {
    this.canEditInvoice();
    item.approved = true;
    item.approvedUserId = this.doctor.id;
  }

  clearApproved(item: LineItem) {
    this.canEditInvoice();
    item.approved = false;
    item.approvedUserId = '';
  }

  changeDefaultLocation(location: LineItemLocation) {
    this.canEditInvoice();
    this.selectedLocation = location;
  }

  changeDateOnLineItem(item: LineItem, date: Date) {
    this.canEditInvoice();
    this.dateOfWork = date; // Update the default for new line items
    if (LineItemTypesWithOverrides.includes(item.lineItemCategory)) {
      this.checkReminderOverride(item);
    }
  }

  changeDefaultDoctor(doctor: UserOption) {
    this.canEditInvoice();
    this.doctor = doctor;
  }

  changeDefaultAsstDoctor(doctor: UserOption) {
    this.canEditInvoice();
    this.asstDoctor = doctor;
  }

  changeDefaultDiscount(discount: DiscountSummary) {
    this.canEditInvoice();
    this.discount = JSON.parse(JSON.stringify(discount));
  }

  setLocation(locationId: string, lineItem: LineItem) {
    this.canEditInvoice();
    const location = this.locations.find((x) => x.id === locationId);
    this.selectedLocation = JSON.parse(JSON.stringify(location));
    lineItem.location = this.selectedLocation;
  }

  isLocationDisabled(lineItem: LineItem): boolean {
    if (!lineItem.location || !lineItem.location.id) {
      return false;
    }
    return !this.locations.find(loc => loc.id === lineItem.location.id);
  }

  getDisabledLocationName(lineItem: LineItem): string {
    if (!lineItem.location) {
      return 'Disabled Location';
    }
    return `${lineItem.location.branchName + ' ' + lineItem.location.name || 'Disabled Location'}`;
  }

  setDoctor(lineItem: LineItem, userName: string) {
    this.canEditInvoice();
    const doctor = this.doctors.find((x) => x.name === userName);
    // Create a deep copy to ensure each line item has its own independent doctor object
    lineItem.doctor = JSON.parse(JSON.stringify(doctor));
    lineItem.doctorCode = doctor.doctorCode;
    // Also create a deep copy for the default to prevent shared references
    this.changeDefaultDoctor(JSON.parse(JSON.stringify(doctor)));
  }

  setAsstDoctor(lineItem: LineItem, userName: string) {
    this.canEditInvoice();
    const doctor = this.doctors.find((x) => x.name === userName);
    // Need to account for assisting doctor being null / empty
    // Create a deep copy to ensure each line item has its own independent doctor object
    lineItem.asstDoctor = doctor ? JSON.parse(JSON.stringify(doctor)) : new UserAccount();
    lineItem.assistingDoctorCode = doctor ? doctor.doctorCode : null;
    // Also create a deep copy for the default to prevent shared references
    this.changeDefaultAsstDoctor(doctor ? JSON.parse(JSON.stringify(doctor)) : null);
  }

  setDiscount(lineItem: LineItem, discountId: string) {
    this.canEditInvoice();
    this.renderTableRows();
    if (!discountId) {
      lineItem.discount = JSON.parse(JSON.stringify(new DiscountSummary()));
      lineItem.discountId = '';
      lineItem.discountName = '';
      lineItem.totalPrice = this.calculateLineItemPrice(lineItem);
      this.discount = new DiscountSummary();
    } else {
      const discount = JSON.parse(
        JSON.stringify(this.discounts.find((x) => x.id === discountId)),
      );
      lineItem.discount = discount;
      lineItem.discountId = discount.id;
      lineItem.discountName = discount.name;
      lineItem.totalPrice = this.calculateLineItemPrice(lineItem) * discount.decimalPercentage;
      this.changeDefaultDiscount(discount);
    }
    this.renderTableRows();
  }

  updateSelected(): void {
    this.canEditInvoice();
    const dialogRef = this.dialog.open(UpdateLineItemsComponent, {
      width: '600px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        return;
      }

      const lineItemChanges = result as UpdateLineItems;
      this.selection.selected.forEach((lineItem) => {
        const listItem = this.dataSource.data.find((x) => x === lineItem);

        // A null or undefined ID represents a field that wasn't changed.
        // An empty ID represents a field that should be reset.

        // The new value has to be copied, otherwise changes to individual
        // rows would affect every other row.

        // Changes to the location
        if (lineItemChanges.location.id != null) {
          if (lineItemChanges.location.id === '') {
            throw Error(
              'Location cannot be unset. This may be a bug with update-line-items',
            );
          }
          listItem.location = JSON.parse(
            JSON.stringify(lineItemChanges.location),
          );
          this.changeDefaultLocation(listItem.location);
        }

        // Changes to the date
        if (lineItemChanges.dateOfWork != null) {
          listItem.dateOfWork = lineItemChanges.dateOfWork;
          this.changeDateOnLineItem(listItem, lineItemChanges.dateOfWork);
        }

        // Changes to the main doctor
        if (lineItemChanges.doctor.id != null) {
          if (lineItemChanges.doctor.id === '') {
            throw Error(
              'Doctor cannot be unset. This may be a bug with update-line-items',
            );
          }
          listItem.doctor = JSON.parse(JSON.stringify(lineItemChanges.doctor));
          listItem.doctorCode = lineItemChanges.doctor.doctorCode;
          this.changeDefaultDoctor(listItem.doctor);
        }

        // Changes to the assisting doctors
        if (lineItemChanges.asstDoctor.id != null) {
          if (lineItemChanges.asstDoctor.id !== '') {
            listItem.asstDoctor = JSON.parse(
              JSON.stringify(lineItemChanges.asstDoctor),
            );
            listItem.assistingDoctorCode =
              lineItemChanges.asstDoctor.doctorCode;
          } else {
            listItem.asstDoctor = new UserAccount();
            listItem.assistingDoctorCode = null;
          }
          this.changeDefaultAsstDoctor(listItem.asstDoctor);
        }

        // Applied Discounts
        if (lineItemChanges.discount.id != null) {
          listItem.totalPrice = this.calculateLineItemPrice(lineItem);

          if (lineItemChanges.discount.id !== '') {
            listItem.discount = JSON.parse(JSON.stringify(lineItemChanges.discount));
            listItem.discountId = lineItemChanges.discount.id;
            listItem.discountName = lineItemChanges.discount.name;
            listItem.totalPrice *= lineItemChanges.discount.decimalPercentage;
          } else {
            listItem.discount = new DiscountSummary();
            listItem.discountId = null;
            listItem.discountName = null;
          }

          this.changeDefaultDiscount(listItem.discount);
        }
      });
    });
  }

  getDiscounts() {
    this.subscriptions.add(
      this.discountsService.index().subscribe((res) => {
        this.discounts = res;
      }),
    );
  }

  getDoctors() {
    this.subscriptions.add(
      this.accountService.getDoctorOptions().subscribe((res) => {
        this.doctors = res;
        for (const item of this.dataSource.data) {
          if (item.doctor.name && !this.doctors.find((x) => x.id === item.doctor.id)) {
            // Push a deep copy to prevent shared references
            this.doctors.push(JSON.parse(JSON.stringify(item.doctor)));
          }
          if (item.asstDoctor.name && !this.doctors.find(x => x.id === item.asstDoctor.id)) {
            // Push a deep copy to prevent shared references
            this.doctors.push(JSON.parse(JSON.stringify(item.asstDoctor)));
          }
        }
        const currentDoctor = this.accountService
          .currentUserValue as unknown as UserAccount;
        if (this.doctors.filter((x) => x.id === currentDoctor.id).length > 0) {
          this.doctor = JSON.parse(
            JSON.stringify(
              this.doctors.filter((x) => x.id === currentDoctor.id)[0],
            ),
          );
        } else {
          this.doctor = JSON.parse(
            JSON.stringify(this.doctors.filter((x) => x.userName === 'NP')[0]),
          ) as UserAccount;
        }

        this.subscriptions.add(
          this.locationService
            .getInventoryLocations()
            .subscribe(this.setLocations.bind(this)),
        );
      }),
    );
  }

  // A real patient must have a non-empty, non-empty-GUID id. The Quick Entry
  // "Clear Client and Patient" action assigns a new Patient() (id ''), and a
  // persisted patientless invoice comes back with the all-zero GUID; both must
  // be treated as "no patient".
  get hasSelectedPatient(): boolean {
    return (
      !!this.selectedPatient &&
      !!this.selectedPatient.id &&
      this.selectedPatient.id !== LineItemFormComponent.EMPTY_GUID
    );
  }

  printDialog(selectedItems: LineItem[]) {
    if (!this.hasSelectedPatient) {
      this.snackBar.open(
        'A patient is required before printing labels. Please add a patient to this invoice.',
        'Error',
        {
          duration: 4000,
        },
      );
      return;
    }

    const dialogRef = this.dialog.open(PrintDialogComponent, {
      disableClose: true,
      height: 'auto',
      width: 'auto',
      data: {
        selectedClient: this.selectedClient,
        selectedPatient: this.selectedPatient,
        selectedItems,
        isWhiteboard: false,
      },
    });

    const sub = dialogRef.componentInstance.lineItemsToPrint.subscribe(
      (data: any) => {
        this.printLabel(data);
      },
    );

    dialogRef.afterClosed().subscribe((result) => {});
  }

  printLabel(selectedItems: LineItem[]) {
    for (const item of selectedItems) {
      item.isPrinted = true;
    }

    this.lineItemsToPrint = selectedItems;
    this.cdr.detectChanges();
    const printContent = document.getElementById('print');
    const WindowPrt = window.open(
      '',
      '',
      'left=0,top=0,toolbar=0,scrollbars=0,status=0',
    );
    WindowPrt.document.write(printContent.innerHTML);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.onafterprint = () => WindowPrt.close();
    WindowPrt.print();
  }

  public discard() {
    this.lineItemInputService.discardLineItemDraft().subscribe((res) => {
      this.selection.clear();
      this.dataSource.data = [];
      this.addRow(0);
      this.renderTableRows();
      this.submitted = false;
      this.snackBar.open('Draft was removed', 'Success', {
        duration: 2000,
      });
    });
  }

  removeItem(lineItem: LineItem) {
    this.canEditInvoice();
    if (
      this.invoiceData.id != null &&
      lineItem.hasOwnProperty('id') &&
      lineItem.id
    ) {
      this.removeInvoiceItem(lineItem);
      return;
    }

    if (this.dataSource.data.length > 1) {
      this.dataSource.data = this.dataSource.data
        .filter((x) => x !== lineItem)
        .sort((x) => x.position);

      this.dataSource.data.forEach((item, index) => {
        item.position = index + 1;
      });

      this.renderTableRows();

      setTimeout(() => {}, 2000);
    } else {
      this.snackBar.open('Must have at least one line item', 'Warning', {
        duration: 2000,
      });
    }
  }

  copySelected() {
    this.canEditInvoice();

    this.lineItemClipboard.length = 0;

    for (const lineItem of this.selection.selected) {
      // Need to make a copy so that changes to the source item aren't propagated to this copy
      const copiedLineItem = JSON.parse(JSON.stringify(lineItem)) as LineItem;
      copiedLineItem.lineItemRequest = null;
      copiedLineItem.controlledSubstanceLogs = [];
      if (copiedLineItem.lineItemCategory === 'MedicationsAndSupplies') {
        copiedLineItem.needsRequest = false;
      }
      this.lineItemClipboard.push(copiedLineItem);
    }

    // Persist clipboard
    storage.setItem(
      LocalStorageNames.LineItemClipboard,
      this.lineItemClipboard,
    );

    this.selection.clear();
  }

  pasteSelected(listPasteIndex: number) {
    const aboveDateOfWork =
      listPasteIndex > 0
        ? this.dataSource.data[listPasteIndex - 1].dateOfWork
        : new Date(Date.now());

    // Insert line items from clipboard
    for (let i = 0; i < this.lineItemClipboard.length; i++) {
      // Need to make a copy so that items can be pasted more than once
      const newLineItem = JSON.parse(JSON.stringify(this.lineItemClipboard[i]));

      newLineItem.dateOfWork = aboveDateOfWork;
      newLineItem.id = null;

      this.dataSource.data.splice(listPasteIndex + i, 0, newLineItem);
      this.showLineItemDialogs(newLineItem);
    }

    // Update positions
    for (let i = listPasteIndex; i < this.dataSource.data.length; i++) {
      const lineItem = this.dataSource.data[i];
      lineItem.position = i + 1;
    }

    this.renderTableRows();
  }

  deleteSelected() {
    this.canEditInvoice();
    const selectionIds = this.selection.selected
      .filter((x) => x.id != null)
      .map(({ id }) => id);

    if (this.invoiceData.id !== undefined && this.invoiceData.id !== null) {
      if (this.invoiceData.isEstimate) {
        this.estimateService.deleteItems(selectionIds).subscribe(
          (x) => this.deleteSuccess(selectionIds),
          (error) =>
            this.snackBar.open('Line items could not be removed', 'Error', {
              duration: 2000,
            }),
        );
      } else {
        this.lineItemInputService
          .removeInvoiceItems(this.invoiceData.id, selectionIds)
          .subscribe(
            (x) => this.deleteSuccess(selectionIds),
            (error) =>
              this.snackBar.open('Line items could not be removed', 'Error', {
                duration: 2000,
              }),
          );
      }
    } else {
      this.selection.selected.forEach((lineItem) => {
        this.removeItem(lineItem);
      });

      this.selection.clear();
    }
  }

  deleteSuccess(selectionIds: string[]) {
    this.dataSource.data = this.dataSource.data
      .filter((y) => !selectionIds.includes(y.id))
      .sort((y) => y.position);

    this.dataSource.data.forEach((item, index) => {
      item.position = index + 1;
    });

    this.renderTableRows();

    this.selection.clear();
    this.calculateInvoiceTotal();
    this.invoiceEventService.itemsUpdated(this.invoiceData.id);
    this.snackBar.open('Line Items have been removed', 'Success', {
      duration: 2000,
    });
  }

  // Items that Invoice Id
  removeInvoiceItem(lineItem: LineItem) {
    this.canEditInvoice();

    const request = this.invoiceData.isEstimate
      ? this.estimateService.deleteLineItem(lineItem.id)
      : this.lineItemInputService.removeInvoiceItem(
          this.invoiceData.id,
          lineItem.id,
          this.keepRevisions,
        );

    request.subscribe(
      (x) => {
        this.dataSource.data = this.dataSource.data
          .filter((y) => y.id !== lineItem.id)
          .sort((y) => y.position);
        this.dataSource.data.forEach((item, index) => {
          item.position = index + 1;
        });

        this.renderTableRows();

        this.invoiceEventService.itemsUpdated(this.invoiceData.id);
        this.calculateInvoiceTotal();

        this.snackBar.open('Line Item has been removed', 'Success', {
          duration: 2000,
        });
      },
      (error) => {
        this.snackBar.open('Line item could not be removed', 'Error', {
          duration: 2000,
        });
      },
    );
  }

  hideInvoiceItem(lineItem: LineItem) {
    this.canEditInvoice();
    this.lineItemInputService
      .hideInvoiceItem(this.invoiceData.id, lineItem.id)
      .subscribe(
        (x) => {
          lineItem.hideFromInvoice = true;
          this.invoiceEventService.itemsUpdated(this.invoiceData.id);
          this.snackBar.open('Line Item has been hidden', 'Success', {
            duration: 2000,
          });
        },
        (error) => {
          this.snackBar.open('Line item could not be hidden', 'Error', {
            duration: 2000,
          });
        },
      );
  }

  updateSubmissionWithSelected() {
    this.submission.clientId = this.selectedClient.id;
    this.submission.patientId = this.selectedPatient.id;
    this.submission.selectedClient = this.selectedClient;
    this.submission.selectedPatient = this.selectedPatient;
    this.submission.lineItems = this.dataSource.data;
  }

  // New functions
  submitLineItems(invoice: Invoice) {
    // Ignore a second submit while the co-occurrence check / warning dialog for
    // the first one is still in flight, so the same unsaved line items are not
    // posted (and duplicated) twice.
    if (this.isSubmitting) {
      return;
    }

    // Estimates skip the co-occurrence warning check — it's an invoice-billing
    // accuracy feature, not relevant to estimates.
    if (this.invoiceData.isEstimate) {
      this.executeSubmitLineItems(invoice);
      return;
    }

    // The warning endpoint computes from the posted model; the invoice id is
    // only used for optional (null-safe) telemetry. Brand-new invoices have no
    // id yet, so send the empty-GUID sentinel and still run the check rather
    // than skipping it — the highest-volume "Create New Invoice" path was
    // otherwise never checked.
    const invoiceId = (invoice && invoice.id) || this.invoiceData.id || LineItemFormComponent.EMPTY_GUID;

    // Mirrors the branch executeSubmitLineItems takes: a passed invoice with an id means the
    // rows are ADDED to that existing invoice (addLineItems), so the server must also count
    // the items already saved on it. The update-in-place path (invoiceData.id) posts the full
    // grid, where persisted rows may have just been deleted, and a new invoice has nothing
    // persisted, so neither unions persisted items.
    const includePersistedItems = invoice != null && invoice.id !== undefined;

    this.updateSubmissionWithSelected();
    this.isCheckingMissingItems = true;
    this.isSubmitting = true;
    let hasStartedSubmit = false;
    try {
      this.subscriptions.add(
        this.lineItemInputService.checkCooccurrenceWarnings(invoiceId, this.submission, includePersistedItems).subscribe(
          (warnings) => {
            this.isCheckingMissingItems = false;
            // Only a real, non-empty array opens the dialog. A null/empty result
            // or any malformed success body (a non-array) fails open: submit
            // without a dialog rather than throwing and silently dropping it.
            if (!Array.isArray(warnings) || warnings.length === 0) {
              hasStartedSubmit = true;
              this.isSubmitting = false;
              this.executeSubmitLineItems(invoice);
              return;
            }

            let dialogRef;
            try {
              dialogRef = this.dialog.open(MissingItemsDialogComponent, {
                width: '70vw',
                maxWidth: '70vw',
                height: '80vh',
                data: { warnings },
              });
            } catch (dialogError) {
              // Defence in depth: never let a dialog render failure block billing.
              this.isSubmitting = false;
              this.executeSubmitLineItems(invoice);
              return;
            }

            this.subscriptions.add(
              dialogRef.afterClosed().subscribe((proceed) => {
                this.isSubmitting = false;
                if (proceed) {
                  this.executeSubmitLineItems(invoice);
                }
              }),
            );
          },
          // If the warnings service is unavailable, proceed without blocking the user.
          () => {
            this.isCheckingMissingItems = false;
            hasStartedSubmit = true;
            this.isSubmitting = false;
            this.executeSubmitLineItems(invoice);
          },
        ),
      );
    } catch (error) {
      this.isCheckingMissingItems = false;
      this.isSubmitting = false;
      if (hasStartedSubmit) {
        throw error;
      }
      this.executeSubmitLineItems(invoice);
    }
  }

  private executeSubmitLineItems(invoice: Invoice) {
    if (this.invoiceData.isEstimate) {
      this.updateSubmissionWithSelected();
      // Clear controlled substance logs for estimates
      for (const lineItem of this.submission.lineItems) {
        lineItem.controlledSubstanceLogs = [];
      }
      if (this.invoiceData.id) {
        this.estimateService
          .update(this.submission, this.invoiceData.id)
          .subscribe((res) => {
            this.dataSource.data = res.lineItems;

            this.dataSource.data.forEach((item, index) => {
              item.position = index + 1;
            });

            this.renderTableRows();
            this.selection.clear();

            this.snackBar.open('Estimate has been updated.', 'Success', {
              duration: 2000,
            });
            this.invoiceEventService.itemsUpdated(this.invoiceData.id);
          }, (error) => this.showSaveError(error, 'Estimate could not be updated.'));
      } else {
        this.estimateService.create(this.submission).subscribe((res) => {
          if (this.sendEstimateEmail) {
            this.estimateService
              .sendEmail(res.id)
              .subscribe(
                (emailRes) => {
                  this.snackBar.open(
                    'Estimate email successfully sent.',
                    'Success',
                    {
                      duration: 2000,
                    },
                  );
                },
                (error) => {
                  this.snackBar.open(
                    'Failed to send estimate email.',
                    'Error',
                    {
                      duration: 2000,
                    },
                  );
                },
              );
          }
          if (this.printEstimateAfterSubmit) {
            this.listCommunicationsService.printEstimateEmail(res.id).subscribe(
              (blob) => {
                FileSaver.saveAs(blob, 'Estimate.pdf');
              },
              (error) => {
                this.snackBar.open('Failed to print estimate.', 'Error', {
                  duration: 2000,
                });
              }
            );
          }

          // Reset flags
          this.sendEstimateEmail = false;
          this.printEstimateAfterSubmit = false;

          // Clear form
          this.selection.clear();
          this.dataSource.data = [];
          this.addRow(0);
          this.renderTableRows();
          this.submitted = false;

          this.invoiceData.type = EntityWithLineItemsType.Invoice;

          this.snackBar.open('New estimate successfully created.', 'Success', {
            duration: 2000,
          });
          this.invoiceEventService.itemsUpdated(res.id);
        });
      }
    } else if (invoice === null || invoice.id === undefined) {
      this.updateSubmissionWithSelected();
      if (invoice !== null && invoice.id === undefined) {
        this.submission.invoiceStatus = invoice.invoiceStatus;
      }

      if (this.invoiceData.id) {
        this.lineItemInputService
          .updateLineItems(
            this.submission,
            this.invoiceData.id,
            this.keepRevisions,
          )
          .subscribe((res) => {
            this.dataSource.data = res.lineItems;

            this.dataSource.data.forEach((item, index) => {
              item.position = index + 1;
            });

            this.renderTableRows();
            this.selection.clear();

            this.snackBar.open('Invoice has been updated.', 'Success', {
              duration: 2000,
            });
            this.invoiceEventService.itemsUpdated(res.id);
          }, (error) => this.showSaveError(error, 'Invoice could not be updated.'));
      } else {
        this.lineItemInputService.submitLineItems(this.submission).subscribe(
          (response) => {
            this.snackBar.open('Invoice submitted.', 'Success', {
              duration: 2000,
            });

            // Discard
            this.selection.clear();
            this.dataSource.data = [];
            this.addRow(0);
            this.renderTableRows();
            this.submitted = false;
            this.invoiceEventService.itemsUpdated(this.invoiceData.id);
            this.calculateInvoiceTotal();
          },
          (error) => {
            this.snackBar.open('Invoice could not be submitted.', 'Error', {
              duration: 2000,
            });
          },
        );
      }
    } else {
      this.lineItemInputService
        .addLineItems(
          this.selectedClient.id,
          this.selectedPatient.id,
          this.dataSource.data,
          invoice.id,
          invoice.invoiceStatus,
        )
        .subscribe((response) => {
          this.snackBar.open('Invoice Submitted', 'Success', {
            duration: 2000,
          });
          this.invoiceEventService.itemsUpdated(invoice.id);

          // Discard
          this.selection.clear();
          this.dataSource.data = [];
          this.addRow(0);
          this.renderTableRows();
          this.submitted = false;
        });
    }
  }

  /// Switches form to estimate mode
  convertToEstimate(): void {
    this.invoiceData.type = EntityWithLineItemsType.Estimate;
    this.dataSource.data.forEach((item) => {
      item.controlledSubstanceLogs = [];
    });
    this.renderTableRows();
  }

  // If submitted then update instead
  updateLineItems() {
    this.canEditInvoice();
    if (!this.invoiceData.isEstimate) {
      for (const lineItem of this.dataSource.data) {
        if (lineItem.isControlledSubstance && (!lineItem.controlledSubstanceLogs || lineItem.controlledSubstanceLogs.length === 0)) {
          this.snackBar.open(
            `Controlled Substance log is required for line item: ${lineItem.name}`,
            'Error',
            {
              duration: 4000,
            },
          );
          return;
        }
      }
    }

    if (!this.invoiceData.isEstimate && this.invoiceData.id == null) {
      const dialogRef = this.dialog.open(InvoiceSelectionComponent, {
        width: '600px',
        data: this.clientInvoices,
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (!result) {
          return;
        }
        this.submitLineItems(result);
      });
    } else {
      this.submitLineItems(null);
    }
  }

  get unapprovedItems() {
    if (this.dataSource.data) {
      return this.dataSource.data.filter(
        (x) => !x.approved && x.name !== '' && x.itemId !== '',
      ).length as number;
    } else {
      return 0 as number;
    }
  }

  printLabels(lineItems: LineItem[]) {
    window.print();
  }

  showRefillsDialog(lineItem) {
    if (this.invoiceData.isEstimate) {
      return;
    }

    const previousRefillData = lineItem.lineItemRequest;

    const dialogData = new RefillsDialogData();
    dialogData.IsEditable =
      lineItem.lineItemRequest === null ||
      lineItem.lineItemRequest === undefined ||
      (lineItem.lineItemRequest.refillStatus !== 'DroppedOff' &&
        lineItem.lineItemRequest.refillStatus !== 'PickedUp');
    dialogData.LineItem = lineItem;

    const dialogRef = this.dialog.open(RefillsDialogComponent, {
      disableClose: true,
      height: 'auto',
      width: 'auto',
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((data) => {
      const lineItemInput = data as LineItem;

      // If finalizing request / setting status to picked up, confirm with user
      if (
        lineItemInput.lineItemRequest.refillStatus === 'PickedUp' ||
        lineItemInput.lineItemRequest.refillStatus === 'DroppedOff'
      ) {
        const confDialogRef = this.dialog.open(ConfirmationDialogComponent, {
          height: 'auto',
          width: 'auto',
          data: {
            header: 'Approve Request',
            body: `You are about to complete a request for ${this.selectedClient.name}`,
          },
        });

        confDialogRef.afterClosed().subscribe((result) => {
          if (result && lineItemInput != null) {
            lineItem.lineItemRequest.refillDate =
              lineItemInput.lineItemRequest.refillDate;
            lineItem.lineItemRequest.refillStatus =
              lineItemInput.lineItemRequest.refillStatus;
            lineItem.lineItemRequest.refillStatusDate =
              lineItemInput.lineItemRequest.refillStatusDate;
            lineItem.lineItemRequest.refillStatusUserId =
              lineItemInput.lineItemRequest.refillStatusUserId;
          } else {
            lineItem.lineItemRequest = previousRefillData;
          }
        });
      }

      if (lineItemInput !== null && lineItemInput !== undefined) {
        const existingLineItem = this.dataSource.data.find(
          (x) => x.position === lineItemInput.position,
        );
        existingLineItem.lineItemRequest = lineItemInput.lineItemRequest;
        if (
          existingLineItem.lineItemRequest.refillStatusUserId !== null &&
          existingLineItem.lineItemRequest.refillStatusUserId !== undefined
        ) {
          existingLineItem.needsRequest = true;
        }
      }
      this.cdr.detectChanges();
    });
  }

  setAutoCompleteIndex(i: number) {
    this.autocompleteIndex = i;
  }

  getInvoiceOrEstimateTitle(): string {
    return this.invoiceData.isEstimate ? 'ESTIMATE' : 'INVOICE';
  }

  calculateLineItemPrice(item: LineItem) {
    item.pricePerUnit = Number(item.pricePerUnit.toFixed(2));
    const minimumCost = item.minimumCost !== null && item.pricePerUnit > 0 && item.quantity > 0 ? item.minimumCost : 0;

    return (item.pricePerUnit * item.quantity) + minimumCost;
  }

  // A 409 from the invoice or estimate save means an overlapping save changed the same
  // controlled substance log first (#2681). The API rolled this save back and says to reload,
  // so show its message; anything else gets the generic failure text.
  private showSaveError(error: any, fallbackMessage: string): void {
    const message = error && error.status === 409 && error.error && error.error.message
      ? error.error.message
      : fallbackMessage;
    this.snackBar.open(message, 'Error', {
      duration: 6000,
    });
  }
}
